/** @graphql cc **/

import gql from 'graphql-tag';

export const FooterCreateButtonsQuery = gql`
	query FooterCreateButtonsQuery($spaceKey: String) {
		space(key: $spaceKey) {
			id
			key
			spaceTypeSettings {
				enabledContentTypes {
					isLivePagesEnabled
					isWhiteboardsEnabled
					isDatabasesEnabled
				}
			}
			didContainUserContent
			id
			operations {
				operation
				targetType
			}
		}
	}
`;
